module.exports = "https://cdn.hellotech.com/client-assets/HT_techJose_6070d0841e347a6e5420c1e84da83a14.jpg";